import { Grid, Tab } from '@material-ui/core';
import { animated } from '@react-spring/web';

export const AnimatedGrid = animated(Grid);
export const AnimatedTab = animated(Tab);